export default __webpack_public_path__ + "static/media/androidStore.c483a932.png";